var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project"},[(_vm.projectId)?_c('s-sidebar'):_vm._e(),_c('s-creations'),_c('router-view'),_c('invisible-render-queue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }